import React from 'react'
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import {  useGetPurchasetaxByNameQuery } from '../../../../store/api/Purchasetax';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import Attachment from '../../../../utils/Attachment';
function Tax() {
    const location = useLocation()
    const purchaseId = location?.state?.purchaseId
    const navigate = useNavigate()
    const [tab, settab] = useState(1)
    const [taxes, setTaxes] = useState([])
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
  
    const { data, isLoading, isError } = useGetPurchasetaxByNameQuery(purchaseId);
    const [formdata, setformdata] = useState({
        title: "",
        taxcategory: "",
        company: "",
        default: false,
        disabled: false
    });

    const [detaildata, setDetaildata] = useState([])

    useEffect(() => {
        if (data?.data) {
            const { title, tax_category, company, is_default, disabled } = data.data
            setDetaildata(data.data.taxes)
            setformdata({
                title: title || "",
                taxcategory: tax_category || "",
                company: company || "",
                default: Boolean(is_default),
                disabled: Boolean(disabled)
            })

        }

    }, [data])

    console.log(detaildata,"detaildata");
    

    const handlechange = (e) => {
        const { name, value } = e.target;
        setformdata((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    // const handleSubmit = async () => {
    //     const payload = { title: formdata.title, company: formdata.company, tax_category: formdata.taxcategory, is_default: formdata.default, disabled: formdata.disabled, taxes: taxes };
    //     try {
    //         const res = await createSalesTax(payload).unwrap();
    //         setError('Sales Taxes and Charges Template created successfully!');
    //         setptype('Success');
    //         setShowError(true);
    //         setTimeout(() => {
    //             navigate('/master/tax/tax-list')
    //         }, 3000);
    //     } catch (error) {
    //         const parsedMessages = JSON.parse(error.data._server_messages);
    //         const firstMessageObj = JSON.parse(parsedMessages[0]);
    //         console.log(firstMessageObj, "errr");
    //         setError(firstMessageObj.message);
    //         setptype('Error');
    //         setptype('Error');
    //         setShowError(true);
    //     }
    // };
    return (
        <>
            <FormLayoutTwo
                title="View Purchase Taxes and Charges Template"
                breadcrumbs={[
                    { label: " Taxes and Charges Template" },
                    { label: " Taxes and Charges Template List", url: "/master/tax/purchase-tax-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                               <Attachment doctype="Purchase Taxes and Charges Template"  docname={purchaseId}  /> 
                        </div>
                    </div>

                     <div className=" " style={{ background: '' }}>
                                        <div className="row">
                                          <div className="col-12">
                                            <div >
                                              <Tab1 setformdata={setformdata} formdata={formdata} handlechange={handlechange}  setTaxes={setTaxes} taxes={taxes}  detaildata={detaildata}  purchaseId={purchaseId}  />
                                            </div>
                                          </div>
                                        </div>
                                      </div>        

                   
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    )
}

export default Tax
